<template>
  <div class="section" id="disor">
    <canvas id="canvas"></canvas>

  </div>
  
</template>
<script>
 

export default {
  name: 'Disor',

}
</script>


